export function checkHttpsAndWrapUrlsInCorsProxy(url, corsProxyPrefix) {
    if(url && !url.match('^(https:\/\/|blob:)')) {
        if(url === "N") { url = null; }
        else {
            url = corsProxyPrefix + url;
        }
    }
    return url;
}
// example url: http://com-youappi-dsp-cdn.s3-website-us-east-1.amazonaws.com/creatives/games/1592/variations/3749/24391_97653278-233c-49d0-a95d-c7041cc4670d.png
export function changeDNSPrefix(url) {
    if (url && url.match('^http:\/\/com-youappi-dsp-cdn.s3-website-us-east-1.amazonaws.com/creatives')) {
        return url.replace(/http:\/\/com-youappi-dsp-cdn.s3-website-us-east-1.amazonaws.com\/creatives/, 'https:\/\/creatives.dsp.youappi.com');
    }
    return url;
}

export function changeHttpToHttps(url) {
    let httpsUrl;
    if(url) {
        if(url.match('^https:\/\/')) {
            httpsUrl = url;
        } else if(url.match('^http:\/\/')) {
            httpsUrl = url.replace(/http:\/\//, 'https:\/\/');
        } else {
            httpsUrl = url;
        }
    }
    return httpsUrl;
}

export function getProxyPrefix(host = window.location.host) {
    console.log(host)
    if (host.contains("simplaex.com"))
        return "https://luftbruecke.simplaex.net/?uri=";
    else
        return "https://luftbruecke.dsp.youappi.com/?uri=";
};



/** WEBPACK FOOTER **
 ** ./src/common/util/url-util.js
 **/